const wait = async (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const getGraphQLErrorCode = (error, errorCode) => {
  return error.graphQLErrors.find(
    (error2) => error2.extensions?.code === errorCode || error2.extensions?.exception.originalError?.extensions?.code === errorCode
  );
};
const formatClientVersionInfo = (versions) => {
  return Object.entries(versions || {}).map((parts) => parts.join("@")).join("/");
};
export {
  formatClientVersionInfo,
  getGraphQLErrorCode,
  wait
};
//# sourceMappingURL=utils.js.map
